/* ld-footer-partners.js
   Lighting Direct — make the "OUR PARTNERS" footer block collapse into an
   accordion on mobile, matching the sibling footer menu columns (which use
   Horizon's `menu--accordion`). The partners block is a `group` of images, so
   it can't use the native menu accordion; this progressively enhances it.

   Desktop is untouched: the caret is hidden and the body stays open (all the
   collapse styling in ld-footer.css is gated to <=749px). Idempotent + safe if
   the block is absent. Ref: Teamwork 41748521 (Global) comment 5. */
(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';

  function init() {
    var footer = document.querySelector('.footer-content');
    if (!footer) return;

    // Find the OUR PARTNERS group: the group-block-content whose heading text
    // is exactly "OUR PARTNERS" and that holds the partner logos.
    var heading = null;
    var group = null;
    var textBlocks = footer.querySelectorAll('.text-block');
    for (var i = 0; i < textBlocks.length; i++) {
      if (/^\s*OUR PARTNERS\s*$/i.test(textBlocks[i].textContent || '')) {
        var g = textBlocks[i].closest('.group-block-content');
        if (g && g.querySelectorAll('img').length >= 1) {
          heading = textBlocks[i];
          group = g;
          break;
        }
      }
    }
    if (!group || group.hasAttribute('data-ld-partners')) return;

    // Move everything after the heading (the logo image blocks) into a
    // collapsible body wrapper.
    var body = document.createElement('div');
    body.className = 'ld-partners__body';
    var passedHeading = false;
    Array.prototype.slice.call(group.children).forEach(function (child) {
      if (child === heading) { passedHeading = true; return; }
      if (passedHeading) body.appendChild(child);
    });
    if (!body.children.length) return; // nothing to collapse
    group.appendChild(body);

    // Caret that matches the sibling menu accordions (clone one if present).
    var sibling = document.querySelector('.footer-content .menu__heading__toggle');
    var toggle = sibling
      ? sibling.cloneNode(true)
      : (function () {
          var s = document.createElement('span');
          s.className = 'menu__heading__toggle svg-wrapper icon-caret icon-animated';
          s.innerHTML = '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 5.5L7 9.5L3 5.5" stroke="currentColor" stroke-width="1.5"/></svg>';
          return s;
        })();
    toggle.classList.add('ld-partners__toggle');

    heading.classList.add('ld-partners__summary');
    heading.appendChild(toggle);
    heading.setAttribute('role', 'button');
    heading.setAttribute('tabindex', '0');

    group.setAttribute('data-ld-partners', ''); // CSS scope + idempotency marker

    function isMobile() { return window.matchMedia(MOBILE).matches; }
    function toggleOpen() {
      if (!isMobile()) return; // desktop is always open (body visible, caret hidden)
      var open = group.classList.toggle('ld-partners--open');
      heading.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    heading.setAttribute('aria-expanded', 'false');
    heading.addEventListener('click', toggleOpen);
    heading.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        toggleOpen();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
